export default {
  user: state => state.user,
  avatar: state => state.user.user.avatar,
  theme: state => state.theme,
  permission: state => state.user.permission
}
